




import { Component, Vue } from 'vue-property-decorator';
const scrollIntoView = require('scroll-into-view');

@Component
export default class ScrollNextSection extends Vue {
    scrollToNextSection(e: Event) {
        const headerHeight = document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0].clientHeight : 0;
        const topOffset = window.innerWidth < 767.98 ? headerHeight + 88 : headerHeight + 64;

        const scrollOptions = {
            align: {
                top: 0,
                topOffset: topOffset,
            },
        };

        const nextSection = (<HTMLElement>e.target)?.closest('section')?.nextElementSibling;
        scrollIntoView(nextSection, scrollOptions);
    }
}
